import { CSSProperties } from 'react'

import { Paper, Stack } from '@mui/material'
import { EtaRange } from './components/fields/EtaRange'
import { Message } from './components/fields/Message'
import { NotificationBackup } from './components/fields/NotificationBackup'
import { NotificationBackupSubject } from './components/fields/NotificationBackupSubject'
import { NotificationTime } from './components/fields/NotificationTime'
import { NotificationWay } from './components/fields/NotificationWay'
import { Subject } from './components/fields/Subject'
import { Threshold } from './components/fields/Threshold'
import { Tolerance } from './components/fields/Tolerance'
import { TrackingLink } from './components/fields/TrackingLink'
import { UnsubscribeInstructions } from './components/fields/UnsubscribeInstructions'

import { useNotificationBehavior } from './hooks/useNotificationBehavior'

import type { NotificationFormType } from '@/notificationForms'

const PaperStyle: CSSProperties = {
  background: '#F3F5F7',
  padding: '24px 16px',
}

interface Props {
  notification: NotificationFormType
}

export function NotificationForm(props: Props) {
  const { notification } = props

  // Retrieves notification behavior to check which notification ways are allowed
  const notificationBehavior = useNotificationBehavior()

  return (
    <>
      <NotificationTime />

      <Tolerance />

      <Threshold />

      <NotificationWay notificationBehavior={notificationBehavior} />

      <Subject />

      <Message notification={notification} />

      <Paper elevation={0} sx={PaperStyle}>
        <Stack direction="column" spacing={3}>
          <EtaRange />

          <Stack direction="column" spacing={3} paddingLeft={1}>
            <TrackingLink />

            <UnsubscribeInstructions />

            <NotificationBackup />

            <NotificationBackupSubject />
          </Stack>
        </Stack>
      </Paper>
    </>
  )
}
